// The little the elements in this folder are allowed to remember about a visitor: that they closed the
// popup, that they answered the cookie notice, when their evergreen countdown started. Nothing here
// identifies anyone, and nothing here is written while the merchant is editing — a builder session must
// not be able to teach a shop that its own popup has already been dismissed.

/** How long an element remembers: `visit` dies with the tab, `visitor` survives it. */
export type MemoryScope = 'visit' | 'visitor';

/** Everything this folder writes is prefixed, so a shop's own keys and these can never collide. */
const PREFIX = 'xs-el:';

// Picks the store a scope means, or null when this browser refuses storage altogether.
function storeFor(scope: MemoryScope): Storage | null {
  if (typeof window === 'undefined') return null;
  try {
    return scope === 'visit' ? window.sessionStorage : window.localStorage;
  } catch {
    return null;
  }
}

// Reads what an element remembered about this visitor, or null when it remembered nothing.
export function readMemory(key: string, scope: MemoryScope): string | null {
  try {
    return storeFor(scope)?.getItem(PREFIX + key) ?? null;
  } catch {
    return null;
  }
}

// Remembers one small fact, silently doing nothing where the browser will not have it.
export function writeMemory(key: string, scope: MemoryScope, value: string): void {
  try {
    storeFor(scope)?.setItem(PREFIX + key, value);
  } catch {
    /* A visitor in private mode still gets the popup; they just get it again next time. */
  }
}
